import translations from './nickel.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/nickel'

export const nickel: Metal = {
  id: 15,
  slug: 'nickel',
  name: t.name,
  symbol: 'Ni',
  mines: [
    {
      name: 'IMIP & IWIP (Indonesia, Morowali & Weda Bay, Sulawesi/Halmahera)',
      region: 'IMIP & IWIP',
      coordinates: [122.1, -2.98],
    },
    {
      name: 'Sorowako (Indonesia, Vale)',
      region: 'Sorowako',
      coordinates: [121.36, -2.54],
    },
    {
      name: 'Norilsk-Talnakh (Russia, Nornickel — Arctic Circle)',
      region: 'Norilsk-Talnakh',
      coordinates: [88.2, 69.33],
    },
    {
      name: 'Sudbury basin (Canada, Vale/Glencore)',
      region: 'Sudbury basin',
      coordinates: [-80.99, 46.49],
    },
    {
      name: 'Koniambo (New Caledonia)',
      region: 'Koniambo',
      coordinates: [164.73, -20.96],
    },
  ],
  countries: [
    { name: 'Indonesia', percent: 59.5 },
    { name: 'Philippines', percent: 8.9 },
    { name: 'Russia', percent: 5.7 },
    { name: 'Canada', percent: 5.1 },
    { name: 'New Caledonia', percent: 3 },
  ],
  content: {
    smartphone: {
      quantityScore: 3,
      quantityLabel: t.smartphone.label,
      parts: ['electronics', 'camera', 'battery', 'casing'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 3, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
      ],
      secondBento: [
        {
          src: `${dir}/04.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/05.jpg`,
          orientation: 'vertical',
        },
      ],
    },
  },
}
